var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 25,
    viewBox: "0 0 27 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6587 0.869652L8.47066 7.3337L1.33775 8.37361C0.0586097 8.55913 -0.454022 10.1361 0.473597 11.0393L5.63409 16.068L4.41354 23.1716C4.19384 24.4556 5.54621 25.4174 6.67888 24.8169L13.0599 21.4628L19.441 24.8169C20.5737 25.4125 21.926 24.4556 21.7063 23.1716L20.4858 16.068L25.6463 11.0393C26.5739 10.1361 26.0613 8.55913 24.7821 8.37361L17.6492 7.3337L14.4611 0.869652C13.8899 -0.282549 12.2348 -0.297196 11.6587 0.869652Z",
    fill: "#020C41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGold);
export default __webpack_public_path__ + "static/media/gold.dcb18d914cf1ce065ecd4c543a04c881.svg";
export { ForwardRef as ReactComponent };